import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tablist',
  imports: [CommonModule],
  templateUrl: './tablist.component.html',
})
export class TablistComponent {
  @Input() tabs: string[] = [];
  @Input() activeTab: number = 0;
  @Output() activeTabChange: EventEmitter<number> = new EventEmitter<number>();

  onTabClick(tab: number): void {
    this.activeTab = tab;
    this.activeTabChange.emit(tab);
  }
}
